// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Js_exn from "rescript/lib/es6/js_exn.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Core__Option from "@rescript/core/src/Core__Option.mjs";
import * as JsxRuntime from "react/jsx-runtime";
import * as Caml_js_exceptions from "rescript/lib/es6/caml_js_exceptions.js";
import * as RelayRouter__Utils from "./RelayRouter__Utils.mjs";
import * as RelayRouter__Context from "./RelayRouter__Context.mjs";
import * as RelayRouter__Internal from "./RelayRouter__Internal.mjs";

var tmp;

if (import.meta.env.SSR) {
  tmp = {};
} else {
  try {
    tmp = Core__Option.getOr(Core__Option.map(Caml_option.nullable_to_opt(sessionStorage.getItem("RESCRIPT_RELAY_ROUTER_SCROLL_POS")), (function (positionsRaw) {
                return JSON.parse(positionsRaw);
              })), {});
  }
  catch (raw_exn){
    var exn = Caml_js_exceptions.internalToOCamlException(raw_exn);
    if (exn.RE_EXN_ID === Js_exn.$$Error) {
      tmp = {};
    } else {
      throw exn;
    }
  }
}

var scrollPositionsY = {
  contents: tmp
};

var context = React.createContext(undefined);

var make = context.Provider;

function RelayRouter__Scroll$TargetScrollElement$Provider(props) {
  var targetElementRef = props.targetElementRef;
  var id = props.id;
  return JsxRuntime.jsx(make, {
              value: React.useMemo((function () {
                      if (targetElementRef !== undefined) {
                        return {
                                id: id,
                                targetElementRef: targetElementRef
                              };
                      }
                      
                    }), [
                    id,
                    targetElementRef
                  ]),
              children: props.children
            });
}

var Provider = {
  make: RelayRouter__Scroll$TargetScrollElement$Provider
};

function useTargetElement() {
  return React.useContext(context);
}

function getScrollPosId($$location, id) {
  return id + ":" + $$location.key;
}

function getElement(targetElement) {
  if (targetElement.TAG === "Window") {
    return Caml_option.some(targetElement._0);
  } else {
    return Caml_option.nullable_to_opt(targetElement._0.current);
  }
}

function RelayRouter__Scroll$ScrollRestoration(props) {
  var $$location = RelayRouter__Utils.useLocation();
  var router = RelayRouter__Context.useRouterContext();
  var targetEl = React.useContext(context);
  var match = React.useMemo((function () {
          if (targetEl !== undefined) {
            return [
                    targetEl.id,
                    {
                      TAG: "Element",
                      _0: targetEl.targetElementRef
                    }
                  ];
          } else {
            return [
                    "window",
                    {
                      TAG: "Window",
                      _0: window
                    }
                  ];
          }
        }), [targetEl]);
  var targetElement = match[1];
  var id = match[0];
  var setScrollPosition = React.useCallback((function () {
          var targetElement$1 = getElement(targetElement);
          if (targetElement$1 !== undefined) {
            scrollPositionsY.contents[getScrollPosId($$location, id)] = Caml_option.valFromOption(targetElement$1).scrollTop;
            return ;
          }
          
        }), [
        $$location,
        targetElement,
        id
      ]);
  var persistScrollPositions = React.useCallback((function (priority) {
          var targetElement$1 = getElement(targetElement);
          if (targetElement$1 !== undefined) {
            scrollPositionsY.contents[getScrollPosId($$location, id)] = Caml_option.valFromOption(targetElement$1).scrollTop;
            RelayRouter__Internal.runAtPriority((function () {
                    var stringifiedPositions = JSON.stringify(scrollPositionsY.contents);
                    if (stringifiedPositions !== undefined) {
                      sessionStorage.setItem("RESCRIPT_RELAY_ROUTER_SCROLL_POS", stringifiedPositions);
                      return ;
                    }
                    
                  }), priority);
            return ;
          }
          
        }), [
        $$location,
        targetElement,
        id
      ]);
  var onBeforeUnload = React.useCallback((function () {
          setScrollPosition();
          persistScrollPositions("High");
        }), [
        setScrollPosition,
        persistScrollPositions
      ]);
  React.useEffect((function () {
          window.addEventListener("beforeunload", onBeforeUnload);
          return (function () {
                    window.removeEventListener("beforeunload", onBeforeUnload);
                  });
        }), [onBeforeUnload]);
  React.useEffect((function () {
          return router.subscribeToEvent(function ($$event) {
                      switch ($$event.TAG) {
                        case "OnBeforeNavigation" :
                            setScrollPosition();
                            return persistScrollPositions("Low");
                        case "RestoreScroll" :
                            var $$location = $$event._0;
                            var match = getElement(targetElement);
                            var match$1 = scrollPositionsY.contents[getScrollPosId($$location, id)];
                            if (match === undefined) {
                              return ;
                            }
                            var targetElement$1 = Caml_option.valFromOption(match);
                            if (match$1 !== undefined) {
                              targetElement$1.scrollTo(0, match$1);
                              return ;
                            }
                            var hashElement = document.getElementById($$location.hash.slice(1));
                            if (hashElement == null) {
                              targetElement$1.scrollTo(0, 0);
                            } else {
                              hashElement.scrollIntoView();
                            }
                            return ;
                        case "OnRouteWillUnmount" :
                            return ;
                        
                      }
                    });
        }), [
        router.subscribeToEvent,
        setScrollPosition,
        persistScrollPositions,
        targetElement,
        $$location
      ]);
  return null;
}

var TargetScrollElement = {
  Provider: Provider,
  useTargetElement: useTargetElement
};

var ScrollRestoration = {
  make: RelayRouter__Scroll$ScrollRestoration
};

export {
  TargetScrollElement ,
  ScrollRestoration ,
}
/* scrollPositionsY Not a pure module */
